import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-licence-req-grid',
  templateUrl: './psa-licence-req-grid.component.html',
  styleUrls: ['./psa-licence-req-grid.component.css']
})
export class PsaLicenceReqGridComponent implements OnInit {
  title="Licence";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-licence-request/psa-licence-req-grid/psa-licence-req-grid.component.ts